<div id="testing" class="me-self-report">

    <ng-container *ngIf="data && data.content.component === 'selfEvaluationHelpCard'">
        <me-sr-help-card [callApi]="false" [blockData]="data" (updateUI)="updateUI()"></me-sr-help-card>
    </ng-container>

    <ng-container *ngIf="data && data.content.component === 'selfEvaluationLivingConditions'">
        <me-sr-living-conditions [callApi]="false" [blockData]="data" (updateUI)="updateUI()"></me-sr-living-conditions>
    </ng-container>

    <ng-container *ngIf="data && data.content.component === 'selfEvaluationPersonalInformationCard'">
        <ng-container *ngIf="data.content.form[0].component === 'checkboxFieldComponent'">
            <me-sr-personal-information [callApi]="false" [blockData]="data" (updateUI)="updateUI()"></me-sr-personal-information>
        </ng-container>

        <ng-container *ngIf="data.content.form[0].component !== 'checkboxFieldComponent'">
            <me-sr-difficulties [callApi]="false" [blockData]="data" (updateUI)="updateUI()"></me-sr-difficulties>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="showSuccessPage">
        <me-sr-success-card></me-sr-success-card>
    </ng-container>
</div>